export function compact<E>(array: (E | undefined)[]): E[] {
    return array.reduce((a, e) => e !== undefined ? [...a, e] : a, [] as E[]);
}
